/**
 * @file 号码卡片
 * @author (zhaomiaoyuan@baidu.com)
 * 路由：demo/金华市绿源电动车有限公司
 */

import React, {useState, useEffect} from 'react';
import {withRouter, useParams} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import PhoneCard from '../preview/phoneCard';
import LandingPage from '../preview/landingPage';
import {businessCardinfo} from '../../actions/businessCard';
import {fetchCompanyDetail} from '../../actions/userCenterAction';
import {fetchV1Search} from '../../actions/searchAction';
import {Toast} from '@baidu/spui';
// mock
// import {detail} from './conf';

const Demo = props => {
    const {fetchCompanyDetail, businessCardinfo, fetchV1Search} = props;

    const {company} = useParams();
    const [companyDetail, setCompanyDetail] = useState({});
    const [landingPageDetail, setLandingPageDetail] = useState({});
    const [hasMicroCard, setHasMicroCard] = useState(false);

    useEffect(() => {
        fetchCompanyDetail({company: company}).then(data => {
            if (data.code === 200) {
                // 模拟数据
                setCompanyDetail(data.data);
                // 存在企业简介
                const hasMicroCardFlag = data.data.company_introduction.length > 0;
                if (hasMicroCardFlag) {
                    setHasMicroCard(hasMicroCardFlag);
                    businessCardinfo({
                        company_name: company
                    }).then(res => {
                        const resp = res.data || {};
                        resp.detailed_loc = resp.detailed_loc && JSON.parse(resp.detailed_loc);
                        resp.open_info = resp.open_info && JSON.parse(resp.open_info);
                        resp.company_adverts = resp.company_adverts && resp.company_adverts.split(';');

                        setLandingPageDetail(resp);
                    });
                    return;
                }
                searchFn();
            }
        });
    }, []);
    const searchFn = () => {
        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            const searchInfo = company + '客服电话';
            let json = {
                data: localData.data,
                key_id: localData['key_id'],
                sign: localData.sign,
                search: searchInfo
            };
            fetchV1Search(json).then(data => {
                if (data.code === 200) {
                    let pageObj = {};
                    let key = Object.keys(data.data)[0];
                    let typeObj = data.data[key];

                    if (!Object.keys(data.data).length) {
                        return;
                    }

                    if (typeObj['customer']) {
                        pageObj = typeObj['customer'][0];
                    }
                    setLandingPageDetail(pageObj);
                } else {
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }
            });
        };
    };

    return (
        <div style={{margin: '80px 0'}}>
            <PhoneCard detail={companyDetail}></PhoneCard>
            <LandingPage hasMicroCard={hasMicroCard} landingPageDetail={landingPageDetail}></LandingPage>
        </div>
    );
};

Demo.propTypes = {
    history: PropTypes.any,
    businessCardinfo: PropTypes.func,
    fetchCompanyDetail: PropTypes.func,
    fetchV1Search: PropTypes.func
};

function mapDispatchToProps(dispatch) {
    return {
        businessCardinfo: obj => businessCardinfo(dispatch, obj),
        fetchV1Search: (type, obj) => fetchV1Search(dispatch, type, obj),
        fetchCompanyDetail: obj => fetchCompanyDetail(dispatch, obj)
    };
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Demo));
